import { ElementRef, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable()
export class ElementShowHideService {

    static readonly STYLE_ATTRIBUTE = 'style';
    static readonly STYLE_DISPLAY_NONE = 'display: none !important;';
    static readonly STYLE_DISPLAY_NONE_REGEX = new RegExp(ElementShowHideService.STYLE_DISPLAY_NONE, 'gi');

    private renderer: Renderer2;

    constructor(rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    show(el: ElementRef): void {
        const style = this.getStyle(el).replace(ElementShowHideService.STYLE_DISPLAY_NONE_REGEX, '');
        this.setStyle(el, style);
    }

    hide(el: ElementRef): void {
        const style = this.getStyle(el).concat(ElementShowHideService.STYLE_DISPLAY_NONE);
        this.setStyle(el, style);
    }

    isHidden(el: ElementRef): boolean {
        return this.getStyle(el).indexOf(ElementShowHideService.STYLE_DISPLAY_NONE) !== -1;
    }

    private getStyle(el: ElementRef): string {
        if (el instanceof ElementRef) {
            return el.nativeElement.getAttribute(ElementShowHideService.STYLE_ATTRIBUTE) || ''
        }
        return '';
    }

    private setStyle = (el: ElementRef, style: string): void => {
        if (el instanceof ElementRef) {
            this.renderer.setAttribute(el.nativeElement, ElementShowHideService.STYLE_ATTRIBUTE, style);
        }
    };
}
